import { render, staticRenderFns } from "./levitated.vue?vue&type=template&id=3359fded&scoped=true"
import script from "./levitated.vue?vue&type=script&lang=js"
export * from "./levitated.vue?vue&type=script&lang=js"
import style0 from "./levitated.vue?vue&type=style&index=0&id=3359fded&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_idpt5aadqkxzu6szyh7dhosqta/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3359fded",
  null
  
)

export default component.exports